module.exports = __webpack_public_path__ + "static/AppSore-491a0c730b0d22dd5d663168236fa169.svg";